@if (url$ | async | safeResourceUrl; as safeUrl) {
  <iframe [attr.data-cy]="'support-form'" #iFrame [src]="safeUrl" title="Support form"></iframe>
}
